/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClickableDiv from 'components/Common/ClickableDiv';
import Styles from './index.module.css';

export default function StyledRadioButton({
  children,
  className,
  selected,
  ...props
}) {
  return (
    <ClickableDiv
      className={
        classNames(
          Styles.radioButton,
          className,
          {
            [Styles.radioButtonSelected]: selected,
          },
        )
      }
      {...props}
    >
      {children}
    </ClickableDiv>
  );
}

StyledRadioButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  selected: PropTypes.bool,
};

StyledRadioButton.defaultProps = {
  children: null,
  className: '',
  selected: false,
};
